import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'ERP',
		url: '/erp',
		icon: 'industry',
	},
	{
		name: 'Station Management',
		url: '/erp/stations',
		icon: 'cogs',
	},
];

export default class MrpStations extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar
					breadcrumbs={breadcrumbsStatic}
					history={this.props.history}
				/>
				<Objects.MrpStation history={this.props.history}/>
			</div>
		);
	}
}
